export default "__VITE_ASSET__BrcoaSJ2__"